import restArguments from './restArguments.js';
import difference from './difference.js';

// Return a version of the array that does not contain the specified value(s).
export default restArguments(function(array, otherArrays) {
  return difference(array, otherArrays);
});



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/without.js
// module id = 983
// module chunks = 0